import { cn } from '@/lib/cn';

export interface AccountPlayerCardProps {
  displayName: string;
  username: string;
  initials: string;
  className?: string;
}

export function AccountPlayerCard({
  displayName,
  username,
  initials,
  className,
}: AccountPlayerCardProps) {
  const handle = username.startsWith('@') ? username : username ? `@${username}` : '';

  return (
    <div
      className={cn(
        'flex w-full items-center justify-center gap-3 rounded-md border border-border-default bg-bg-surface p-3',
        className,
      )}
    >
      <div
        className="flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-action-primary"
        aria-hidden
      >
        <span className="text-label-m font-bold text-text-on-action">{initials}</span>
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5 overflow-hidden leading-none">
        <p className="truncate text-label-m font-bold text-text-primary">
          {displayName || handle || '—'}
        </p>
        {handle ? (
          <p className="truncate text-[11px] text-text-secondary">{handle}</p>
        ) : null}
      </div>
    </div>
  );
}
